import { useEffect } from 'react'
import styled from 'styled-components'
import { useTrackVisibility } from 'react-intersection-observer-hook'

import AdventurePlaceholderCard from '../../../components/cards/AdventureCard/Placeholder'
import WithSelectEscape from '../../../components/SelectEscape/WithSelectEscape'
import { Content } from '../../../components/cards/shared/styled'

import SuggestedAdventureCard from './SuggestedAdventureCard'

const Wrapper = styled.div`
  margin: 0 -16px;
`

const PlaceholderCardWrapper = styled.div``

export const HorizontalListWrapper = styled.div`
  transform: translate3d(0, 0, 0);
  margin: 0 -8px;
  overflow: hidden;
`

export const HorizontalListTrack = styled.div`
  height: 100%;
  width: 100%;
  overflow-y: hidden;
`

export const HorizontalListItem = styled.div`
  display: inline-block;
  vertical-align: top;
  width: 264px;
  margin: 0 8px;

  &:first-child {
    margin-left: 24px;
  }

  ${Content} {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }
`

export const HorizontalList = styled.div`
  height: 100%;
  overflow-y: auto;
  white-space: nowrap;
  overflow-x: scroll;
  -webkit-overflow-scrolling: touch;

  padding-bottom: 30px;
  padding-right: 15px;
  margin-bottom: -30px;

  &::-webkit-scrollbar {
    display: none;
  }
`

interface AdventureCardListProps {
  adventures: GQL_AdventureCardFragmentFragment[]
  loading?: boolean
  canFetchMore?: boolean
  onFetchMore: (...args: any) => any
  bookingAdventuresIndex: GQL_BookingAdventuresIndex
  bucketListItemsIndex: GQL_BucketListItemsIndex
  inItineraryContext?: boolean
  showReviewScore?: boolean
}

const AdventureCardList = ({
  adventures,
  loading,
  canFetchMore,
  onFetchMore,
  bookingAdventuresIndex,
  bucketListItemsIndex,
  inItineraryContext,
  showReviewScore,
}: AdventureCardListProps) => {
  const [loaderRef, { isVisible }] = useTrackVisibility()

  useEffect(() => {
    if (isVisible && canFetchMore && !loading) {
      onFetchMore()
    }
  }, [isVisible, canFetchMore, loading])

  return (
    <Wrapper>
      <HorizontalListWrapper>
        <HorizontalListTrack>
          <HorizontalList>
            {adventures?.map((adventure) => (
              <HorizontalListItem key={adventure.id}>
                <WithSelectEscape
                  itemId={adventure.id}
                  itemType="Adventure"
                  bookingAdventuresIndex={bookingAdventuresIndex}
                  bucketListItemsIndex={bucketListItemsIndex}
                >
                  <SuggestedAdventureCard
                    {...adventure}
                    inItineraryContext={inItineraryContext}
                    showReviewScore={showReviewScore}
                  />
                </WithSelectEscape>
              </HorizontalListItem>
            ))}

            <HorizontalListItem ref={loaderRef}>
              {canFetchMore && (
                <PlaceholderCardWrapper>
                  <AdventurePlaceholderCard />
                </PlaceholderCardWrapper>
              )}
            </HorizontalListItem>
          </HorizontalList>
        </HorizontalListTrack>
      </HorizontalListWrapper>
    </Wrapper>
  )
}

export default AdventureCardList
